import { render, staticRenderFns } from "./NonVehicleMain.vue?vue&type=template&id=4c2e4039&"
import script from "./NonVehicleMain.vue?vue&type=script&lang=ts&"
export * from "./NonVehicleMain.vue?vue&type=script&lang=ts&"
import style0 from "./NonVehicleMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports